import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as sastActionTypes from '../sastActionTypes';

/**
 * Search short trip destination geolocation
 */
const searchSASTDestinationGeolocation = function* searchSASTDestinationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        sastActionTypes.SEARCH_SAST_DESTINATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const responseAction = yield take([
        sastActionTypes.SEARCH_SAST_DESTINATION_GEOLOCATION_REQUEST_SUCCEEDED,
        sastActionTypes.SEARCH_SAST_DESTINATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: sastActionTypes.SET_SAST_DESTINATION_CANDIDATES,
            payload: {
                locationKey: 'destination',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSASTDestinationGeolocation;
